module.exports = __webpack_public_path__ + "img/paishui4.e06219e8.png";